/**
 * Parses the paste event and extracts images from it.
 * @param clipboardEvent
 */
function retrieveImageFromClipboardAsBlob(clipboardEvent) {
  if (!clipboardEvent.clipboardData || !clipboardEvent.clipboardData.items) {
    return null;
  }

  const items = clipboardEvent.clipboardData.items;
  const images = [];

  Object.keys(items).forEach((key) => {
    // Skip content if not image
    if (items[key].type.indexOf('image') >= 0) {
      // Retrieve image on clipboard as blob
      images.push(items[key].getAsFile());
    }
  });

  if (images.length === 0) {
    return null;
  }

  return images;
}

export default retrieveImageFromClipboardAsBlob;
